import React from "react";
import { observer } from "mobx-react";
import { PodcastActivityTemplate } from "themes/administration/analytics/pages";
import { PodcastActivityViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new PodcastActivityViewStore(rootStore, componentProps),
    "podcastActivityViewStore"
)
@observer
class PodcastActivity extends React.Component {
    render() {
        return <PodcastActivityTemplate {...this.props} />;
    }
}

export default PodcastActivity;
